/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

angular.module('ticketspaceApp').directive('planActionsMenu', PlanActionsDirective);
angular.module('ticketspaceApp').directive('supportMenu', SupportMenuDirective);
angular.module('ticketspaceApp').directive('planMenu', PlanMenuDirective);

function PlanActionsDirective() {
	return {
		template: require('html-loader?root=src/!tpl/plan-actions-menu.html'),
	};
}

function SupportMenuDirective() {
	return {
		template: require('html-loader?root=src/!tpl/support-menu.html'),
	};
}

function PlanMenuDirective() {
	return {
		template: require('html-loader?root=src/!tpl/plan-menu.html'),
	};
}
